/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Pagination from "../../Helpers/Pagination";
import dayjs from "dayjs";
import Select from "react-select";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Row, Col, Card, CardBody, Button, Table, Badge, Input } from "reactstrap";
import { toast } from "react-toastify";

const DriverJobLogs = () => {
    const dispatch = useDispatch();

    const [data, setData] = useState([]);
    const [summary, setSummary] = useState({
        total_trips: 0,
        total_office_ot: 0,
        total_after_office_ot: 0,
        total_holiday_ot: 0,
        total_salary: 0
    });

    // Filters State
    const [drivers, setDrivers] = useState([]);
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [searchLorry, setSearchLorry] = useState("");

    const loadLogs = async () => {
        dispatch(loadingTrue());
        let url = `/driver/logs.php?1=1`; // Machan path-ah un file name-ku yethamari mathiko
        if (selectedDriver) url += `&driver_id=${selectedDriver.value}`;
        if (fromDate) url += `&job_date_from=${fromDate.format("YYYY-MM-DD")}`;
        if (toDate) url += `&job_date_to=${toDate.format("YYYY-MM-DD")}`;
        if (searchLorry) url += `&lorry_type=${searchLorry}`;

        const res = await Handler({ method: "get", url });

        if (res?.success) {
            setData(res?.data || []);
            console.log("Logs Response:", res);
            setSummary({
                total_trips: res?.data?.total_trips,
                total_office_ot: res?.data?.total_office_ot_hours,
                total_after_office_ot: res?.data?.total_after_office_ot_hours,
                total_holiday_ot: res?.data?.total_holiday_ot_hours,
                total_salary: res?.data?.total_salary
            });
        }
        dispatch(loadingFalse());
    };

    const loadDrivers = async () => {
        const res = await Handler({ method: "get", url: "/driver/list.php" });
        if (res?.status || res?.success) {
            setDrivers(res?.data?.map(d => ({ value: d.id, label: d.name })));
        }
    };

    useEffect(() => {
        loadDrivers();
        loadLogs();
    }, []);

    const resetFilters = () => {
        setSelectedDriver(null);
        setFromDate(null);
        setToDate(null);
        setSearchLorry("");
        loadLogs();
    };

    return (
        <div className="page-card p-4">
            <div className="page-header mb-4">
                <h4 className="fw-bold text-dark">Driver Job Logs & Salary Report</h4>
            </div>

            {/* ⭐ Summary Cards Section */}
            <Row className="mb-4 g-3">
                <Col md={2}>
                    <Card className="border-0 shadow-sm bg-primary text-white text-center">
                        <CardBody className="p-3">
                            <div className="small opacity-75">Total Trips</div>
                            <h4 className="fw-bold mb-0">{summary.total_trips}</h4>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={2}>
                    <Card className="border-0 shadow-sm bg-info text-white text-center">
                        <CardBody className="p-3">
                            <div className="small opacity-75">Office OT (H)</div>
                            <h4 className="fw-bold mb-0">{summary.total_office_ot}</h4>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card className="border-0 shadow-sm bg-warning text-dark text-center">
                        <CardBody className="p-3">
                            <div className="small opacity-75">After Office OT (H)</div>
                            <h4 className="fw-bold mb-0">{summary.total_after_office_ot}</h4>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={2}>
                    <Card className="border-0 shadow-sm bg-danger text-white text-center">
                        <CardBody className="p-3">
                            <div className="small opacity-75">Holiday OT (H)</div>
                            <h4 className="fw-bold mb-0">{summary.total_holiday_ot}</h4>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card className="border-0 shadow-sm bg-success text-white text-center">
                        <CardBody className="p-3">
                            <div className="small opacity-75">Total Salary Amount</div>
                            <h4 className="fw-bold mb-0">${parseFloat(summary.total_salary).toFixed(2)}</h4>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* ⭐ Filters Section */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className="bg-light p-3 rounded-4 mb-4 shadow-sm border">
                    <Row className="g-2 align-items-end">
                        <Col md={3}>
                            <label className="extra-small fw-bold">Driver</label>
                            <Select options={drivers} value={selectedDriver} onChange={setSelectedDriver} placeholder="All Drivers" isClearable />
                        </Col>
                        <Col md={2}>
                            <label className="extra-small fw-bold">From Date</label>
                            <DatePicker value={fromDate} onChange={setFromDate} slotProps={{ textField: { size: "small", fullWidth: true } }} />
                        </Col>
                        <Col md={2}>
                            <label className="extra-small fw-bold">To Date</label>
                            <DatePicker value={toDate} onChange={setToDate} slotProps={{ textField: { size: "small", fullWidth: true } }} />
                        </Col>
                        <Col md={2}>
                            <label className="extra-small fw-bold">Lorry Type</label>
                            <Input size="sm" value={searchLorry} onChange={e => setSearchLorry(e.target.value)} placeholder="Search Lorry..." />
                        </Col>
                        <Col md={3} className="d-flex gap-2">
                            <Button color="primary" className="flex-grow-1" onClick={loadLogs}>Apply</Button>
                            <Button color="secondary" outline onClick={resetFilters}>Reset</Button>
                        </Col>
                    </Row>
                </div>
            </LocalizationProvider>

            {/* ⭐ Data Table Section */}
            <div className="table-responsive shadow-sm rounded-4 border bg-white">
                <Table hover className="modern-table mb-0 align-middle">
                    <thead className="table-dark">
                        <tr className="small text-uppercase">
                            <th className="p-3 text-white">Date</th>
                            <th className="p-3 text-white">Driver Name</th>
                            <th className="p-3 text-white">Lorry Type</th>
                            <th className="p-3 text-white">Pickup / Delivery</th>
                            <th className="p-3 text-center text-white">Hrs (N/A/H)</th>
                            <th className="p-3 text-center text-white">OT (N/A/H)</th>
                            <th className="p-3 text-end text-white">Salary Amt</th>
                        </tr>
                    </thead>
                    <tbody className="small">
                        {data?.length === 0 ? (
                            <tr><td colSpan="7" className="text-center py-4">No job logs found.</td></tr>
                        ) : data?.list?.map((row) => (
                            <tr key={row.id}>
                                <td className="fw-bold">{dayjs(row.job_date).format("DD-MM-YYYY")}</td>
                                <td>{row.driver_name}</td>
                                <td><Badge color="light" className="text-dark border">{row.lorry_type}</Badge></td>
                                <td style={{ minWidth: "200px" }}>
                                    <div className="extra-small text-muted">FROM: {row.pickup_location}</div>
                                    <div className="extra-small text-muted">TO: {row.delivery_location}</div>
                                </td>
                                <td className="text-center">
                                    {row.office_hrs} / {row.after_office_hrs} / {row.holiday}
                                </td>
                                <td className="text-center fw-bold">
                                    <span className="text-primary">{row.office_hrs_ot}</span> |
                                    <span className="text-warning"> {row.after_office_hrs_ot}</span> |
                                    <span className="text-danger"> {row.holiday_ot}</span>
                                </td>
                                <td className="text-end fw-bold text-success">
                                    ${parseFloat(row.salary_amount).toFixed(2)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default DriverJobLogs;